import React from "react";
import CustomModel from "./customModel";

function InfoRow({ label, value }) {
  return (
    <div className="flex justify-between items-center py-3 border-b border-gray-100 last:border-0">
      <span className="text-sm text-gray-500">{label}</span>
      <span className="text-sm font-medium text-gray-900">{value}</span>
    </div>
  );
}

function UserPopup(props) {
  const { onClose, details, view } = props;
  return (
    <CustomModel
      open={view}
      className="bg-white rounded-3xl"
      onClose={onClose}
      showCloseIcon={true}
    >
      <div className="py-2">
        <div className="flex flex-col items-center mb-4">
          <div className="w-14 h-14 rounded-full bg-primary-bg flex items-center justify-center mb-3">
            <span className="text-xl font-bold text-primary">
              {details.userName ? details.userName.charAt(0).toUpperCase() : "?"}
            </span>
          </div>
          <h2 className="text-lg font-semibold text-gray-900">
            {details.userName}
          </h2>
        </div>
        <div className="bg-gray-50 rounded-2xl px-4 mb-4">
          <InfoRow label="Mobile" value={details.mobileNumber} />
          <InfoRow label="Count" value={details.count} />
          {details.estimate && (
            <InfoRow label="Estimate" value={`${details.estimate}m`} />
          )}
          <InfoRow
            label="Category"
            value={
              details.category
                ? details.category.charAt(0).toUpperCase() +
                  details.category.slice(1)
                : "-"
            }
          />
          {details.notes && <InfoRow label="Notes" value={details.notes} />}
        </div>
        <button
          onClick={onClose}
          className="w-full py-3 bg-primary hover:bg-primary-light rounded-xl text-white font-semibold text-sm"
        >
          Close
        </button>
      </div>
    </CustomModel>
  );
}

export default UserPopup;
